import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SiteListComponent } from '@app/features/services/pages/site-list/site-list.component';
import { SiteDetailComponent } from '@app/features/services/pages/site-detail/site-detail.component';
import { SiteDetailGeneralComponent } from '@app/features/services/pages/site-detail-general/site-detail-general.component';
import { MsalGuard } from '@azure/msal-angular';
import { OnetimeservicesListComponent } from '@app/features/services/pages/onetimeservices-list/onetimeservices-list.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'sites',
    pathMatch: 'full',
  },
  {
    path: 'sites',
    component: SiteListComponent,
    canActivate: [MsalGuard],
    data: { title: 'Sites' },
  },
  {
    path: 'site/:customerId/:siteId',
    component: SiteDetailComponent,
    canActivate: [MsalGuard],
    data: { title: 'Site Detail' },
    children: [
      {
        path: '',
        redirectTo: 'general',
        pathMatch: 'full',
      },
      {
        path: 'general',
        component: SiteDetailGeneralComponent,
        data: {
          title: 'Sites',
          displayBreadCrumb: true,
        },
      },
    ],
  },
  {
    path: 'one-time-services',
    component: OnetimeservicesListComponent,
    canActivate: [MsalGuard],
    data: { title: 'One-Time Service' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServicesRoutingModule { }
